import { FC, useEffect } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps } from ".";
import DateControlViewModel from "../Models/DateControlViewModel";
import DateFormater from "src/Utils/DateFormater";
import { DateBox } from "src/Controls";
import { useFormControls } from "src/Hooks";
import st from "../DynamicForm.module.scss";

interface IDateControlProps extends IFormProps {
	model: DateControlViewModel
};

const DateControl: FC<IDateControlProps> = ( props ) => {

	const { model, readOnly = false, setFieldValue } = props;
	const [ inputProps,, helperProps ] = useField( model.FullPath );
	const { nextFocus } = useFormControls( "#DF" );

	useEffect( () => {
		model.setValue( model.Value );
		helperProps.setValue( model.Value, true );
	// eslint-disable-next-line
	}, [ model.Value ] );

	const onSetValue = ( value: Date | null ) => {
		model.setValue( value );
		setFieldValue( model.FullPath, DateFormater.toShortString(value) );
		model.runValidation();
		if ( !!value )
			nextFocus( model.FullPath );
	};

	const getMaxDate = (): Date|undefined => {
		const val = model.MaxValue;
		if ( !val ) return undefined;
		if ( val === "today" ) {
			const tmp = new Date( Date.now() );
			return new Date( tmp.getFullYear(), tmp.getMonth(), tmp.getDate(), 0,0,0,0 );
		}
		else if ( typeof val === "object" )
			return val;
		else if ( typeof val === "string" ) {
			return new Date( Date.parse(val) );
		}
	};

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling || readOnly }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<DateBox
				name={model.FullPath}
				style={{ minWidth: '160px' }}
				className={st.dateControl}
				variant="blue"
				maxDate={getMaxDate()}
				isError={model.notValidClass}
				value={inputProps.value}				
				disabled={ !model.ControlEnabling || readOnly }
				setValue={onSetValue}
				isArrow
			/>
		</FieldGroup>
	);
};

export default DateControl;
